var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'Branches'
      }
    }
  }, [_vm._v("分店列表")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("分店批次上傳")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-6 d-flex align-items-center"
  }, [_c('h4', {
    staticClass: "mb-2 mb-xl-0 mr-2 font-weight-bold"
  }, [_vm._v("分店批次上傳")])])]), _c('div', {
    staticClass: "d-flex flex-column flex-xl-row mt-4 mb-3 justify-content-between"
  }, [_c('b-breadcrumb', {
    staticClass: "mb-2 p-0",
    attrs: {
      "items": _vm.breadcrumb
    }
  }), _c('div', [_c('b-button', {
    staticClass: "btn btn-outline-primary btn-sm mr-4",
    attrs: {
      "href": "/excel/branch_list_sample.xlsx"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text"
  }), _vm._v("下載範例檔案 ")]), _c('b-form-file', {
    attrs: {
      "id": "fileInput",
      "plain": "",
      "hidden": "",
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    on: {
      "change": _vm.handleUploadFile
    },
    model: {
      value: _vm.form.file,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "file", $$v);
      },
      expression: "form.file"
    }
  }), _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-4",
    attrs: {
      "variant": "primary",
      "tag": "label",
      "for": "fileInput"
    }
  }, [_vm._v(" 請選擇檔案 ")]), _vm.form.file != null ? _c('span', [_vm._v(" " + _vm._s(_vm.form.file.name) + " ")]) : _vm._e(), _c('b-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.form.file != null,
      expression: "form.file != null"
    }],
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.handleSubmitFile
    }
  }, [_vm._v(" 確定上傳 ")])], 1)], 1), _c('div', {
    staticClass: "row my-3"
  }, [_c('div', {
    staticClass: "col-12 col-xl-3"
  }, [_vm.branch ? _c('span', [_vm._v(" 上層分店： " + _vm._s(_vm.branch.name) + " ")]) : _c('span', [_vm._v(" 上層分店： 最上層 ")])]), _c('div', {
    staticClass: "col-12 col-xl-3 offset-1 d-flex align-items-center"
  })]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "accordion",
    attrs: {
      "role": "tablist"
    }
  }, _vm._l(Object.keys(_vm.results), function (key, index) {
    return _c('b-card', {
      key: index,
      staticClass: "mb-1",
      attrs: {
        "no-body": ""
      }
    }, [_c('b-card-header', {
      staticClass: "p-1",
      attrs: {
        "header-tag": "header",
        "role": "tab"
      }
    }, [key === 'failed' ? _c('b-button', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle.accordion-failed",
        modifiers: {
          "accordion-failed": true
        }
      }],
      attrs: {
        "block": "",
        "variant": "info"
      }
    }, [_vm._v("失敗：" + _vm._s(_vm.results.failed.length) + "筆")]) : _vm._e(), key === 'created' ? _c('b-button', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle.accordion-created",
        modifiers: {
          "accordion-created": true
        }
      }],
      attrs: {
        "block": "",
        "variant": "info"
      }
    }, [_vm._v("新增：" + _vm._s(_vm.results.created.length) + "筆")]) : _vm._e(), key === 'existed' ? _c('b-button', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle.accordion-existed",
        modifiers: {
          "accordion-existed": true
        }
      }],
      attrs: {
        "block": "",
        "variant": "info"
      }
    }, [_vm._v("更新：" + _vm._s(_vm.results.existed.length) + "筆")]) : _vm._e()], 1), _c('b-collapse', {
      attrs: {
        "id": "accordion-".concat(key),
        "visible": "",
        "role": "tabpanel"
      }
    }, [_c('b-card-body', [_c('b-table', {
      attrs: {
        "striped": "",
        "hover": "",
        "responsive": "",
        "items": _vm.results[key],
        "fields": _vm.fields,
        "busy": _vm.isLoading
      },
      scopedSlots: _vm._u([{
        key: "table-busy",
        fn: function fn() {
          return [_c('div', {
            staticClass: "text-center my-2"
          }, [_c('b-spinner', {
            staticClass: "align-middle"
          })], 1)];
        },
        proxy: true
      }], null, true)
    })], 1)], 1)], 1);
  }), 1)])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }